/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClassUpdateMetadataResponse
 */
export interface ClassUpdateMetadataResponse {
    /**
     * The ID of the updated class
     * @type {string}
     * @memberof ClassUpdateMetadataResponse
     */
    classId: string;
}

/**
 * Check if a given object implements the ClassUpdateMetadataResponse interface.
 */
export function instanceOfClassUpdateMetadataResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "classId" in value;

    return isInstance;
}

export function ClassUpdateMetadataResponseFromJSON(json: any): ClassUpdateMetadataResponse {
    return ClassUpdateMetadataResponseFromJSONTyped(json, false);
}

export function ClassUpdateMetadataResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClassUpdateMetadataResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'classId': json['classId'],
    };
}

export function ClassUpdateMetadataResponseToJSON(value?: ClassUpdateMetadataResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'classId': value.classId,
    };
}

